import { bootFilmstripPreviews } from './boot';
import { readFilmstripLabels } from './config';
import { setModuleFeed } from './labels';

setModuleFeed(readFilmstripLabels());
bootFilmstripPreviews(document);
